import { render, staticRenderFns } from "./MainZoomEdu.vue?vue&type=template&id=34b29d04&scoped=true&"
import script from "./MainZoomEdu.vue?vue&type=script&lang=js&"
export * from "./MainZoomEdu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b29d04",
  null
  
)

export default component.exports